export const redirectToPurchaseOrderConfirmationPage = (slug: string) => {
  window.open(`/ground-control/purchase-order/${slug}/confirm/`, '_self');
};
